const API = "/api/banners";

export async function getBanners(siteId) {

  const res = await fetch(`${API}?site=${siteId}`);

  if (!res.ok) {
    throw new Error("Erro ao buscar banners");
  }

  return res.json();
}